<template>
  <div>
    <Head title="Create assessments" />
    <h1 class="mb-8 text-3xl font-bold">
      Transaksi
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/assessments">
        Assessment
      </Link>
      <span class="text-indigo-400 font-medium"> / </span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.code"
            :error="form.errors.code"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Code" />
          <select-input
            v-model="form.donation_types_id"
            :error="form.errors.donation_types_id"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Jenis Bantuan">
            <option
              v-for="d in donationTypes"
              :key="d.id"
              :value="d.id">
              {{ d.name }}
            </option>
          </select-input>
          <template v-if="form.donation_types_id == 1">
            <select-input
              v-model="form.paket_m_id"
              :error="form.errors.paket_m_id"
              class="pb-8 pr-6 w-full lg:w-1/2"
              label="Paket">
              <option
                v-for="d in packages"
                :key="d.id"
                :value="d.id">
                {{ d.name }}
              </option>
            </select-input>
            <number-input
              v-model="form.paket_qty"
              :error="form.errors.paket_qty"
              class="pb-8 pr-6 w-full lg:w-1/2"
              input-class="text-right"
              label="Jumlah Paket" />
          </template>
          <number-input
            v-else
            v-model="form.nominal"
            :error="form.errors.nominal"
            class="pb-8 pr-6 w-full lg:w-1/2"
            input-class="text-right"
            label="Nominal" />
          <textarea-input
            v-model="form.desc"
            :error="form.errors.desc"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Description" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Create Assessment
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import TextInput from '@/Shared/TextInput'
import NumberInput from '@/Shared/NumberInput'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextareaInput,
        TextInput,
        NumberInput,
    },
    layout: Layout,
    remember: 'form',
    props: {
        donationTypes: Array,
        packages: Array,
    },
    data () {
        return {
            form: this.$inertia.form({
                code: null,
                donation_types_id: null,
                nominal: 0,
                paket_m_id: null,
                paket_qty: 0,
                desc: null,
            }),
        }
    },
    methods: {
        store () {
            this.form.post('/assessments')
        },
    },
}
</script>
